"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _Services = require("../common_features/utility/Services");
var _AddAccessoryComponent = _interopRequireDefault(require("../components/AddSystem/AddAccessoryComponent"));
var _AddAccessoryInstallationComponent = _interopRequireDefault(require("../components/AddSystem/AddAccessoryInstallationComponent"));
var _RoutePath = _interopRequireDefault(require("../RoutePath"));
var _systemsReducer = require("../common_features/redux/reducers/systemsReducer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const AddAccessory = () => {
  const [accessoryList, setAccessoryList] = (0, _react.useState)([]);
  const [stepCount, setStepCount] = (0, _react.useState)(0);
  const [list, setList] = (0, _react.useState)([]);
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [displayModal, setDisplayModal] = (0, _react.useState)(false);
  const [displayErrorModal, setDisplayErrorModal] = (0, _react.useState)(false);
  const [accessoryData, setAccessoryData] = (0, _react.useState)("");
  const dispatch = (0, _reactRedux.useDispatch)();
  const {
    selectedSystems
  } = (0, _reactRedux.useSelector)(state => state.systems);
  const navigate = (0, _reactRouterDom.useNavigate)();
  const fetchSystemDetail = async () => {
    setIsLoading(true);
    try {
      var _systemData$reference, _systemData$reference2;
      const systemData = await (0, _Services.GetAddSystemDetails)(selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemPartNumber);
      setIsLoading(false);
      const accessoryData = systemData === null || systemData === void 0 ? void 0 : (_systemData$reference = systemData.reference_ids) === null || _systemData$reference === void 0 ? void 0 : (_systemData$reference2 = _systemData$reference.filter(item => item.reference_type === "Accessory")) === null || _systemData$reference2 === void 0 ? void 0 : _systemData$reference2.map(i => ({
        ...i,
        count: 0,
        selectedDate: ""
      }));
      setAccessoryData(accessoryData);
      const sortedArray = accessoryData.sort((a, b) => parseInt(b["Model Number"].slice(2)) - parseInt(a["Model Number"].slice(2)));
      setAccessoryList(sortedArray);
    } catch (error) {
      alert(error);
    }
  };
  const handleAccessoryBack = () => {
    navigate(-1);
  };
  (0, _react.useEffect)(() => {
    fetchSystemDetail();
  }, []);
  const handleAddBtn = item => {
    let arr = accessoryList === null || accessoryList === void 0 ? void 0 : accessoryList.map(acc => {
      return acc["Model Number"] === item ? {
        ...acc,
        count: acc.count === 9 ? 9 : (acc.count || 0) + 1
      } : acc;
    });
    setAccessoryList(arr);
  };
  const handleReduceBtn = item => {
    let arr = accessoryList === null || accessoryList === void 0 ? void 0 : accessoryList.map(acc => {
      return acc["Model Number"] === item ? {
        ...acc,
        count: acc.count === 0 ? 0 : acc.count - 1
      } : acc;
    });
    setAccessoryList(arr);
  };
  const continueBtnClick = () => {
    setStepCount(stepCount + 1);
  };
  const dateChange = (d, name) => {
    let arr = list === null || list === void 0 ? void 0 : list.map(acc => {
      if (acc["Model Number"] === name) {
        return {
          ...acc,
          selectedDate: d
        };
      } else {
        return acc;
      }
    });
    setList(arr);
  };
  const createUpdatedList = async prod => {
    var _systemDetail, _systemDetail$data, _systemDetail$data$da, _systemDetail2;
    let newArr = [];
    let systemDetail = await (0, _Services.getSystemDetails)(selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemId);
    systemDetail = (_systemDetail = systemDetail) === null || _systemDetail === void 0 ? void 0 : (_systemDetail$data = _systemDetail.data) === null || _systemDetail$data === void 0 ? void 0 : (_systemDetail$data$da = _systemDetail$data.data) === null || _systemDetail$data$da === void 0 ? void 0 : _systemDetail$data$da.SystemReferenceMappings;
    let refAppModelNameMap = {};
    let refAppName = (_systemDetail2 = systemDetail) === null || _systemDetail2 === void 0 ? void 0 : _systemDetail2.map(systemDetail => {
      let element = "";
      let str = systemDetail.refAppModelNumber;
      if (str.includes('(')) element = str.slice(0, str.length - 4);else element = str;
      if (refAppModelNameMap[element] === undefined) refAppModelNameMap[element] = 1;else refAppModelNameMap[element]++;
    });
    prod === null || prod === void 0 ? void 0 : prod.map(item => {
      var _Array$from;
      (_Array$from = Array.from({
        length: item.count
      })) === null || _Array$from === void 0 ? void 0 : _Array$from.forEach((i, index) => {
        let name = "";
        let modelnum = refAppModelNameMap["".concat(item["Model Number"], " GAL Tank")];
        if (modelnum === undefined) {
          refAppModelNameMap["".concat(item["Model Number"], " GAL Tank")] = 1;
          name = "".concat(item["Model Number"], " GAL Tank");
        } else {
          modelnum = refAppModelNameMap["".concat(item["Model Number"], " GAL Tank")]++;
          name = "".concat(item["Model Number"], " GAL Tank (").concat(modelnum, ")");
        }
        newArr.push({
          ...item,
          "Model Number": name
        });
      });
    });
    setList(newArr);
  };
  (0, _react.useEffect)(() => {
    createUpdatedList(accessoryList);
  }, [accessoryList]);
  const handleAccInstallationBtn = () => {
    for (let item of list) {
      if (item.selectedDate === "") {
        return true;
      }
    }
    return false;
  };
  const handleBack = () => {
    setStepCount(stepCount - 1);
  };
  const handleCancelbtn = () => {
    navigate(-1);
  };
  const UpdateAccessory = async () => {
    setIsLoading(true);
    const accessoryDataArray = list === null || list === void 0 ? void 0 : list.map(item => ({
      refAppName: item.reference_application,
      refAppType: "Accessory",
      refAppModelNumber: item["Model Number"],
      refAppPartNumber: "#".concat(item.asset.sku_id),
      refAppInstallationDate: item.selectedDate,
      refAppImageUrl: item.asset.url
    }));
    let systemId = selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemId;
    const systemData = {
      storeId: selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.storeId,
      orgId: selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.orgId,
      systemAccessoryRecords: [...accessoryDataArray]
    };
    setIsLoading(false);
    dispatch((0, _systemsReducer.imageData)([]));
    navigate(_RoutePath.default.imageUpload.useLink, {
      state: {
        fromScreen: 'addAccessory',
        filterDetail: systemData.systemAccessoryRecords,
        systemData: systemData,
        changesFlag: true,
        refAppId: null,
        navHeading: 'Add Accessory'
      }
    });
  };
  const onClickContinue = () => {
    navigate(_RoutePath.default.systemDetail.useLink, {
      state: {
        fromScreen: 'addAccessory',
        filterDetail: accessoryData,
        navHeading: 'Add Accessory'
      }
    });
  };
  const handleAccessoryBtnDisable = () => {
    for (let item of accessoryList) {
      if (item.count !== 0) {
        return false;
      }
    }
    return (accessoryList === null || accessoryList === void 0 ? void 0 : accessoryList.length) > 0;
  };
  const retryButtonClick = () => {
    setDisplayErrorModal(false);
  };
  const renderPage = stepCount => {
    // eslint-disable-next-line default-case
    switch (stepCount) {
      case 0:
        {
          return /*#__PURE__*/_react.default.createElement(_AddAccessoryComponent.default, {
            isLoading: isLoading,
            navHeading: "System Dashboard",
            rightNavHeading: "Cancel",
            handleBack: handleAccessoryBack,
            handleCancle: handleCancelbtn,
            headerText: accessoryList !== null && accessoryList !== void 0 && accessoryList.length ? "Add Accessory" : "No Accessories Found!",
            subContent: accessoryList !== null && accessoryList !== void 0 && accessoryList.length ? "These are accessories available for the ".concat(selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemModelNumber, ".") : "These are no accessories available for the below system.",
            continueBtnTitle: accessoryList !== null && accessoryList !== void 0 && accessoryList.length ? "Continue" : "Ok",
            continueBtnDisabled: handleAccessoryBtnDisable(),
            accessoryList: accessoryList,
            handleAddBtn: handleAddBtn,
            handleReduceBtn: handleReduceBtn,
            continueBtnClick: accessoryList !== null && accessoryList !== void 0 && accessoryList.length ? continueBtnClick : handleCancelbtn,
            modelNumber: (selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemPartNumber) + " " + (selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemModelNumber),
            pageNumberNotShow: true
          });
        }
      case 1:
        {
          return /*#__PURE__*/_react.default.createElement(_AddAccessoryInstallationComponent.default, {
            isLoading: isLoading,
            navHeading: "Add Accessory",
            rightNavHeading: "Cancel",
            handleCancle: handleAccessoryBack,
            handleBack: handleBack,
            headerText: "Add Installation Date",
            list: list,
            preText: "What was the installation date?",
            installationText: "Installation Date",
            dateChange: dateChange,
            bottomBtnTitle: "Continue",
            noQrDisabled: handleAccInstallationBtn(),
            navigateToProvisioningDevice: UpdateAccessory,
            modelNumber: (selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemPartNumber) + " " + (selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemModelNumber),
            displayModal: displayModal,
            modalHeaderText: "Accessories Added",
            variant: "password-change-modal",
            variantError: "warning-modal",
            positiveActionButtonTitle: "Continue",
            positiveAction: onClickContinue,
            modalDetailText: "The below accessories have been added to your view",
            modalDetailText3: accessoryData,
            displayErrorModal: displayErrorModal,
            modalHeaderErrorText: "Error",
            modalErrorDetailText: "The accessories could not be added successfully, please try again.",
            retryButtonTitle: "Retry",
            cancelButtonTitle: "Cancel",
            retryButtonClick: retryButtonClick,
            cancelButtonClick: onClickContinue,
            pageNumberNotShow: true
          });
        }
    }
  };
  return renderPage(stepCount);
};
var _default = exports.default = AddAccessory;